import { useUserInfoQuery } from '~/apis/auth';

export function useIsPiracy() {
  const { data: userInfo, isLoading } = useUserInfoQuery();
  const isPiracy = userInfo?.use_piracy || false;

  return { isPiracy, isLoading };
}
